import {
  type AssetsAssetSchema,
  type AssetsAssetSchemaTyped,
  type AssetsAssetSchemaTypedWithId,
  httpPutAssetsByAssetId,
} from '@iconik-io/iconik-api/src/services/assets';

/**
 * A write response types its own id as optional, though the endpoint always
 * sends one back and every caller stores the asset under it.
 */
export const asTypedAsset = (
  body: AssetsAssetSchemaTyped | AssetsAssetSchemaTypedWithId,
): AssetsAssetSchemaTypedWithId =>
  // biome-ignore lint/plugin: see above.
  body as AssetsAssetSchemaTypedWithId;

// TODO FE-7935: both callers only set `type`, so a PATCH would remove the
// need for this.
/**
 * A put replaces the asset, so the generated body demands every required
 * field. The page sends the stored asset merged with its edits, optionally
 * with the nulls stripped out, which carries them but not in a shape the
 * generated type can see. The normalized asset also widens
 * `created_by_user_info` to the user id the entity store keeps.
 */
export const putAssetRequest = (id: string, asset: object) =>
  // biome-ignore lint/plugin: see above.
  httpPutAssetsByAssetId(id, asset as AssetsAssetSchema);
